import { render } from "./setting-dialog-view.vue?vue&type=template&id=590787f6&ts=true"
import script from "./setting-dialog-view.vue?vue&type=script&lang=ts"
export * from "./setting-dialog-view.vue?vue&type=script&lang=ts"

import "./setting-dialog-view.vue?vue&type=style&index=0&id=590787f6&lang=scss"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__